<template>
    <div id="page_Container">
        <div class="page" id="group-list">
            <div id="main-container"  class="main-container">

                <van-pull-refresh v-model="ploading" @refresh="onRefresh" >
                    <van-collapse v-model="activeName" accordion>
                        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                            <div v-for="item in groupData" :key="item.id" class="group-collapse-item">
                                <van-collapse-item title="有赞微商城" :name="item.id">
                                    <div slot="title"><van-tag color="#EE2E50"> {{item.groupName}}</van-tag></div>
                                    <Goods style="padding: 9px 12px" :goodsData="gooditem" v-for="gooditem in item.productGroupItemList" :key="gooditem.productId"></Goods>
                                    <div class="item-footer">
                                        <op-submit-bar
                                            :price="item.groupSellPrice"
                                            :num="item.productGroupItemList.length"
                                            button-text="立即购买"
                                            @submit="onSubmit(item)"
                                            >
                                        </op-submit-bar>
                                    </div>
                                </van-collapse-item>
                                <div v-if="activeName!==item.id" class="group-synopsis">
                                    <div class="group-goods">
                                        <div v-for="(gooditem,i) in item.productGroupItemList" :key="gooditem.productId" class="group-goods-item">
                                            <div class="group-goods-img"><img :src="gooditem.skuImage" alt=""></div>
                                            <div class="group-goods-icon">
                                            <van-icon name="plus" v-if="i<item.productGroupItemList.length - 1"/>
                                            </div>
                                        </div>

                                </div>
                                <div class="group-footer">
                                    <op-submit-bar
                                        :price="item.groupSellPrice"
                                        :num="item.productGroupItemList.length"
                                        :btnShow="false"
                                        button-text="立即购买"
                                        @submit="onSubmit(item)"
                                        >
                                    </op-submit-bar>
                                </div>

                            </div>
                        </div>
                    </van-list>

                    </van-collapse>

                </van-pull-refresh>

            </div>
        </div>
    </div>
</template>

<script>
import Goods from '@/components/common/goods';
import {
    toastLoading,
    clearToastLoading
} from '@/utils/base/utils';
import {
    mapActions
} from 'vuex';
import OPSubmitBar from '@/components/common/opSubmitBar';
export default {
    data() {
        return {
            activeName: '1',
            spreadingCode: '',
            ploading: false,
            loading: false,
            finished: true,
            groupData: [
            ],
            groupTotal: 0,
            productId: '',
            pageNum: 1,
            pageSize: 10
        };
    },
    esvShow() {
        this.productId = this.$route.params.productId;
        this.spreadingCode = this.$route.params.spreadingCode;
        this.setAddressBeginId('-1'); // 清空地址id
        this.onRefresh();
    },
    methods: {
        ...mapActions(['setAddressBeginId']),
        onSubmit(group) {
            const orderJsonList = [];
            group.productGroupItemList.forEach(item => {
                // TODO spreadingCode 套装商品支持分销
                const { productId, skuCode, quantity } = item;
                orderJsonList.push({
                    productId, skuCode, quantity, spreadingCode: this.spreadingCode
                });
            });

            const params = { orderJsonList: JSON.stringify(orderJsonList), participate: 1, usePointFlag: 1, productGroupId: group.id };
            this.$doRequest(
                {
                    url: '/order/settlement',
                    params: params,
                    before: function() {
                        this.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(this.loading);
                    }
                },
                (data) => {
                    const result = data.result;
                    result.orderRespDTOList.forEach((item, index) => {
                        console.log(item.value.activeList);

                        const activeList = item.value.activeList && JSON.parse(item.value.activeList);
                        if (activeList && activeList.length > 0) {
                            activeList.push({ activityId: -1,
                                activityTitle: '不使用活动',
                                activityType: 4
                            });
                        }
                        item.value.activeList = JSON.stringify(activeList);
                    });
                    // TODO 要整整
                    this.ESVStorage.putSavedValue('requireInfo', result);
                    this.ESVStorage.putSavedValue('requireInfoall', result);
                    const arr = [];
                    this.ESVStorage.putSavedValue('invoiceArr', arr);
                    this.ESVStorage.putSavedValue('submitType', '2');
                    this.esvOpenPage({ name: 'OPConfirmOrder', params: { productGroupId: group.id } });
                }
            );
        },
        queryProductGroupList(params) {
            params = params || { productId: this.productId, pageNum: this.pageNum, pageSize: this.pageSize };
            this.$doRequest({
                url: '/groupsell/queryProductGroupList',
                params,
                before: () => {
                    // this.loading = toastLoading();
                },
                complete: () => {
                    this.loading = false;
                    this.ploading = false;
                    // clearToastLoading(this.loading);
                }
            }, (data) => {
                this.groupTotal = data.result.total;
                this.groupData.push(...data.result.list);
                this.activeName = data.result.list.length > 0 && data.result.list[0].id;
                const { endRow, total } = data.result;
                if (endRow >= total) {
                    this.finished = true;
                } else {
                    this.finished = false;
                }
            }, (data) => {
                this.groupData = [];
            });
        },

        onRefresh() {
            this.groupData = [];
            this.pageNum = 1;
            this.queryProductGroupList();

            // this.loading = false;
            console.log('refresh');
        },
        onLoad() {
            // if (this.groupData.length >= this.groupTotal) {
            //     this.finished = true;
            // } else {
            this.pageNum++;
            this.queryProductGroupList();
            // }
        }
    },
    components: {
        Goods,
        'op-submit-bar': OPSubmitBar
    }
};
</script>

<style lang="scss">
#group-list{
    .item-footer {
        margin-right: 10px;
    }
    .group-collapse-item:not(:last-child) {
        margin-bottom: 12px;
    }
    .group-synopsis {
        background: #fff;
        padding: 9px 12px;
        overflow: hidden;
        &::before {
            border-color: #e3e2e2;
            content: ' ';
            position: absolute;
            pointer-events: none;
            box-sizing: border-box;
            left: 15px;
            right: 0;
            bottom: 0;
            transform: scaleY(.5);
            border-bottom: 1px solid #ebedf0;
        }
        .group-goods {
            display: flex;
            overflow: hidden;
            overflow-x: auto;
            &::-webkit-scrollbar  {
                display: none;
                width: 0;
                height: 0;
            }
            &-img {
                width: 80px;
                height: 80px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            &-item {
                display: flex;
                align-items: center;
                color: #979797;
            }
            &-icon {
                width: 28px;
                display: flex;
                justify-content: center;
            }
        }
    }
}

</style>
